﻿const partitionRx = (prescriptions, plans) => ({
  links: prescriptions.map(rx => ({
    rxSer: rx.ser, rx, plans: rx.plans
  })),
  unlinkedPlans: plans.filter(plan =>
    !prescriptions.some(rx => rx.plans.find(rxPlan => rxPlan.ser === plan.ser))
  )
});

export default partitionRx;